import { FC, useCallback, useContext, useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { AutoComplete, Input, theme, message } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

import {
  MenuOption,
  SubMenu,
  UserInformation,
} from '../../../../../../interfaces';

import './index.css';
import { AuthContext } from '../../../../../../contexts';

interface SearchbarProps {
  menus: Array<MenuOption>;
}
interface SearchBarOption {
  path: string;
  value?: string;
  label: string;
}

export const Searchbar: FC<SearchbarProps> = ({ menus }) => {
  const authContext = useContext(AuthContext);
  const resp = authContext.getUserInfo() as UserInformation | null;
  let hasIntermediary = false;
  hasIntermediary = resp?.intermediarioSecundario != null;

  const {
    token: { colorWhite },
  } = theme.useToken();
  const navigate = useNavigate();

  const [options, setOptions] = useState<Array<SearchBarOption>>([]);
  const [open, setOpen] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const setOptionsMenu = useCallback(() => {
    const acc: Array<SearchBarOption> = [];

    menus?.forEach((item: MenuOption) => {
      if (item.subMenues && item.subMenues.length > 0) {
        item.subMenues.forEach((subItem: SubMenu) => {
          acc.push({
            value: subItem.codigo,
            label: subItem.descripcion,
            path: subItem.path,
          });
        });
      } else {
        acc.push({
          value: item.codigo,
          label: item.descripcion,
          path: item.path,
        });
      }
    });

    setOptions(acc);
  }, [menus, setOptions]);

  const filterOptions = (inputValue: any, option: any) =>
    option.label.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1;

  const handleSelect = (value: any, option: any) => {    
    if (hasIntermediary) {
      const { path } = option;

      setOpen(false);
      navigate(path);
      setInputValue('');
      return;
    }

    const messageWarning = 'Debe seleccionar un intermediario.';
    message.warning(messageWarning);
  };

  useEffect(() => {
    setOptionsMenu();
  }, [setOptionsMenu]);

  return (
    <AutoComplete
      options={options}
      onSelect={handleSelect}
      onChange={(value) => {
        setInputValue(value);
        setOpen(value.length > 0);
      }}
      open={open}
      onBlur={() => setOpen(false)}
      className='custom-autocomplete'
      filterOption={filterOptions}
      placeholder='Buscar en el menú'
      value={inputValue}
    >
      <Input
        size='large'
        style={{ color: colorWhite }}
        suffix={<SearchOutlined style={{ color: colorWhite }} />}
      />
    </AutoComplete>
  );
};
